module.exports = __webpack_public_path__ + "img/balkon07.51183398.webp";